module.exports = __webpack_public_path__ + "img/main_architecture_image01_jp.cb187fa1.jpg";